export const getInitials = fullName => {
  if (fullName === undefined) {
    return '';
  }
  const names = fullName.split(/\s+/);
  const initials = names
    .map(name => name.charAt(0))
    .join('')
    .toUpperCase();

  return initials;
};
